(function () {
    'use strict';

    angular
        .module('app')
        .controller('urlapi', urlapi);

    urlapi.$inject = ['$location', 'copyurlservice', 'loginService', '$rootScope', '$stateParams', '$state', '$injector', '$timeout', '$window'];

    function urlapi($location, copyurlservice, loginService, $rootScope, $stateParams, $state, $injector, $timeout, $window) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'urlapi';

        activate();

        function activate() {
            var paramObj;

            if (!angular.equals($location.search(), {})) {
                paramObj = $location.search();
            }
            else {
                var hasProps = false;
                paramObj = $rootScope.routeParams;
                for (var prop in paramObj) {
                    hasProps = true;
                }

                if (!hasProps) {
                    if ($stateParams.params != undefined) {
                        paramObj = $stateParams.params;
                    }
                }

                for (var prop in paramObj) {
                    hasProps = true;
                }
            }

            if (paramObj.code) {
                delete paramObj.code;
            }

            if (angular.equals(paramObj, {})) {
                $state.go("layout.home");
            }
            else {
                var type = paramObj["type"];

                var app = paramObj["app"];

                if (app) {
                    if (app.toLowerCase() === "collabportal") {
                        loginService.refreshToken().then(function(resp) {
                            var access_token = resp.data.access_token;
                            $window.location.href = "../collabportal/main?token=" + access_token;
                        });
                    }
                }
                else {
                    $timeout(function () {
                    
                        if (type) {
                            type = type[0].toUpperCase() + type.substring(1, type.length).toLowerCase();
                            var service = $injector.get("url" + type + "Service");
                            service.execute(paramObj);
                        }
                        else {
                            if (paramObj["fileId"] != undefined && paramObj["fileId"] != null) {
                                copyurlservice.getDocument(paramObj["fileId"]);
                            }
                            if (paramObj["listId"] != undefined && paramObj["listId"] != null) {
                                copyurlservice.getList(paramObj["listId"]);
                            }
                        }
                    }, 250);
                }
            }         
        }
    }
})();
